import React from 'react'
import Hero from '../components/Hero';
import SocialProof from '../components/SocialProof';
import HowItWorks from '../components/HowItWorks';
import CTABanner from '../components/CtaBanner';

const Home = () => {
  return (
    <div>
      <Hero />
      <SocialProof />
      <HowItWorks />
      <CTABanner />
      
    </div>
  )
}

export default Home
